module.exports = __webpack_public_path__ + "img/28_58.e960c0bc.png";